import http from '../http/http';

import { generateEndpoint, HAZARDS } from '../http/endpoints';

const getAllHazards = () => http.get(generateEndpoint(HAZARDS));

export default (() => ({
    getAll: getAllHazards,
}))();
